const QuoteForm = parent => {
	const $ = jQuery;
	const selectsThicknessMapping = {
		'grubosc-blachy-stal-czarna': 'Stal czarna (węglowa)',
		'grubosc-blachy-stal-nierdzewna': 'Stal nierdzewna',
		'grubosc-blachy-aluminium': 'Aluminium'
	};

	if (!$) {
		return false;
	}

	// Initialize row - disable rest of selects
	$('input').on('done_load_repeater', function() {
		$('.repeater-field-item:not(.initialized)').each((rowIndex, row) => {
			$(row).find('.quote-form__sheet-thickness select').each( (i, select) => {
				if (i !== 0) {
					$(select).prop("disabled", true);
					$(select).val("").change();
				}

				select.dataset.initialized = true;
			});

			$(row).addClass('initialized');
		});
	});


	$(document).on('change', '.quote-form__sheet-type select', function(event, el) {
		const selectedValue = this.value;
		const key = Object.keys(selectsThicknessMapping).find(k => selectsThicknessMapping[k] === selectedValue);
		const selectToDisplay = $(this).closest('.quote-form__sheet-type').parent().find(`.quote-form__sheet-thickness select[name^="${key}"]`);

		selectToDisplay.closest('.quote-form__sheet-thickness').find('select').each( (i, select) => {
			$(select).prop("disabled", true);
			$(select).val("").change();
		});

		selectToDisplay.prop("disabled", false);
		selectToDisplay.removeProp("disabled");
		selectToDisplay.val(selectToDisplay.find("option:first").val()).change();
	});
}

export default QuoteForm;